export default __webpack_public_path__ + "static/media/popup-icon-error.f44431de.svg";